export enum PublishSoftwareType{
    WsPublishWebApp,
    WsPublishWebApi,
    WsPublishWindowService,
    WsPublishNodeService,
}